<template>
  <nav
    class="navbar navbar-expand-md fixed-top"
    style="
      margin: auto !important;
      background-color: #fff !important ;
      max-width: 1200px;
      border-bottom: 1px solid #e8e8e8 !important;
      padding-top: 10px;
      display: flex;
      justify-content: space-between;
    "
  >
    <div style="display: flex">
      <img
        src="/assets/logo/t4.png?"
        style="height: 49px; cursor: pointer"
        alt=""
        @click="$router.push('/')"
      />

      <!-- <div
        style="position: relative; margin-right: 20px; width: 50%"
        class="d-none d-md-flex"
      >
        <input
          type="text"
          id="search"
          class="form-control input-search-light"
          autocomplete="disable"
          placeholder="جستجو..."
        />
        <div
          style="
            cursor: pointer;
            margin: auto;
            position: absolute;
            left: 0;
            top: 30%;
          "
        >
          <i class="bi bi-search"></i>
        </div>
      </div> -->
    </div>
    <div>
      <a
        href="/user/agahi/new"
        class="btn btn-dark btn-sm"
        style="padding: 6px 12px; font-size: 12px"
      >
        ثبت آگهی
      </a>
    </div>
  </nav>
</template>



<style>
</style>